import { Injectable } from '@angular/core';
import { ValuesType } from 'utility-types';
import { ServiceID } from '../../form-json.types';
import { OTPSMSRes } from '../api/api.service';
import { FormCoreModule } from '../form-core.module';

@Injectable({
  providedIn: FormCoreModule
})
export class CheckerService {

  constructor() { }

  assign(serviceType: ValuesType<Omit<ServiceID, 'id'>>) {
    switch (serviceType) {
      case 'otp-service':
        return this.otpServiceCheck()
    }
  }

  private otpServiceCheck() {
    return (res: OTPSMSRes) => !!res.status && res.status === '1'
  }
}
